// @flow

import ko from 'rgs-knockout';

import './js/bindings.js';

import { FileUpload2ViewModel } from './js/model';
import template from './templates/template.html';

ko.components.register('file-upload2', {
	viewModel: FileUpload2ViewModel,
	template: template(),
});

export { FileUploadError } from './js/model';
